import React, { FC } from "react";
import { IAdminTitleSeparator } from "./adminTitleSeparator.interface";
import styles from "./adminTitleSeparator.module.scss";

export const AdminTitleSeparator: FC<IAdminTitleSeparator> = ({
  title,
  headerAction,
  children,
  custoStyle,
}) => {
  return (
    <div
      className={`${styles.admin_title_separator} ${styles.fade_in} ${custoStyle}`}
    >
      <div className={styles.header_wrap}>
        <h1 className={styles.title}>{title}</h1>
        {headerAction && <div>{headerAction()}</div>}
      </div>
      {children}
    </div>
  );
};
